const ITEM_SELECTOR = '.jlf-header-desktop__menu-item';
const SUBMENU_SELECTOR = '.jlf-header-desktop__submenu';
const MENU_GRID_SELECTOR = '.mega-menu__grid--jlf[data-jlf-menu-key]';
const IMAGE_TEMPLATE_SELECTOR = 'template[data-jlf-mega-menu-image-template]';
const OPEN_CLASS = 'is-open';
const CLOSE_DELAY = 180;

const initMegaMenuImages = (root = document) => {
  const templates = Array.from(document.querySelectorAll(IMAGE_TEMPLATE_SELECTOR));
  if (templates.length === 0) return;

  root.querySelectorAll(MENU_GRID_SELECTOR).forEach((grid) => {
    if (!(grid instanceof HTMLElement) || grid.querySelector('.mega-menu__feature-image')) return;

    const menuAKey = grid.dataset.jlfMenuAKey;
    const menuKeys = [grid.dataset.jlfMenuKey, grid.dataset.jlfMenuTitleKey].filter(Boolean);
    const template = templates.find(
      (candidate) =>
        candidate instanceof HTMLTemplateElement &&
        candidate.dataset.jlfMegaMenuAKey === menuAKey &&
        menuKeys.includes(candidate.dataset.jlfMegaMenuImageTemplate)
    );

    if (!(template instanceof HTMLTemplateElement)) return;
    grid.append(template.content.cloneNode(true));
  });
};

const initMegaMenuImageObserver = () => {
  if (document.documentElement.dataset.jlfMegaMenuImageObserverReady === 'true') return;

  document.documentElement.dataset.jlfMegaMenuImageObserverReady = 'true';
  let updateQueued = false;

  const observer = new MutationObserver(() => {
    if (updateQueued) return;
    updateQueued = true;

    window.requestAnimationFrame(() => {
      updateQueued = false;
      initMegaMenuImages();
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
};

const initHeaderMenu = (root = document) => {
  const items = Array.from(root.querySelectorAll(ITEM_SELECTOR)).filter((item) => item.querySelector(SUBMENU_SELECTOR));

  items.forEach((item) => {
    if (item.dataset.jlfHeaderMenuReady === 'true') return;

    item.dataset.jlfHeaderMenuReady = 'true';
    const submenu = item.querySelector(SUBMENU_SELECTOR);
    let closeTimer;

    const open = () => {
      window.clearTimeout(closeTimer);
      items.forEach((otherItem) => {
        if (otherItem !== item) otherItem.classList.remove(OPEN_CLASS);
      });
      item.classList.add(OPEN_CLASS);
    };

    const close = () => {
      closeTimer = window.setTimeout(() => {
        if (item.matches(':hover') || submenu?.matches(':hover') || item.contains(document.activeElement)) return;
        item.classList.remove(OPEN_CLASS);
      }, CLOSE_DELAY);
    };

    item.addEventListener('pointerenter', open);
    item.addEventListener('pointerleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', close);

    submenu?.addEventListener('pointerenter', open);
    submenu?.addEventListener('pointerleave', close);
  });

  if (document.documentElement.dataset.jlfHeaderMenuGlobalReady !== 'true') {
    document.documentElement.dataset.jlfHeaderMenuGlobalReady = 'true';

    document.addEventListener('pointerdown', (event) => {
      if (event.target instanceof Element && event.target.closest('.jlf-header-desktop')) return;
      document.querySelectorAll(`${ITEM_SELECTOR}.${OPEN_CLASS}`).forEach((item) => item.classList.remove(OPEN_CLASS));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll(`${ITEM_SELECTOR}.${OPEN_CLASS}`).forEach((item) => item.classList.remove(OPEN_CLASS));
    });
  }
};

initHeaderMenu();
initMegaMenuImages();
initMegaMenuImageObserver();

document.addEventListener('shopify:section:load', (event) => {
  initHeaderMenu(event.target);
  initMegaMenuImages(event.target);
});
